import { render, staticRenderFns } from "./TongYuenSalesOverview.vue?vue&type=template&id=71363c8e"
import script from "./TongYuenSalesOverview.vue?vue&type=script&lang=ts"
export * from "./TongYuenSalesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports